(() => {
 'use strict';
 const contactPath='/pages/kontakt-shopify-agentur-analyse';
 const optedIn=()=>window.kkAuditConsentAllowed?.('analytics')===true;
 function prepare(root=document){
  root.querySelectorAll('[data-kk-cookie-preferences]').forEach(link=>{
   if(link.dataset.kkCookieReady)return;
   link.dataset.kkCookieReady='true';
   link.addEventListener('click',event=>{
    const banner=document.getElementById('cookies-banner');
    if(typeof banner?.showBanner==='function'){event.preventDefault();banner.showBanner();banner.querySelector('button')?.focus();return;}
    if(typeof window.privacyBanner?.showPreferences!=='function')return;
    event.preventDefault();
    Promise.resolve(window.privacyBanner.showPreferences()).catch(()=>{location.href=link.href;});
   });
  });
  root.querySelectorAll('a[href^="https://app.klickkartell.de"]').forEach(a=>{a.target='_blank';a.rel='noopener noreferrer';if(!a.title)a.title='Öffnet die Klickkartell-App in einem neuen Tab';});
  // Header navigation only: the Arcade section and its content remain untouched.
  root.querySelectorAll('.section-header .kk-header-arcade').forEach(a=>a.hidden=true);
  root.querySelectorAll('form').forEach(form=>{
   if(!form.querySelector('input[name="form_type"][value="contact"]')||form.dataset.kkAuditReady)return;
   form.dataset.kkAuditReady='true';
   form.addEventListener('submit',()=>{
    if(!form.checkValidity()||!optedIn())return;
    // A short-lived opaque marker, never contact details. Necessary for success deduplication.
    try{sessionStorage.setItem('kk_contact_pending',JSON.stringify({path:location.pathname,time:Date.now(),id:crypto.randomUUID()}));}catch{}
   });
  });
 }
 function completed(){
  const success=document.querySelector('[data-kk-contact-success]');
  if(!success||!optedIn())return;
  try{
   const raw=sessionStorage.getItem('kk_contact_pending');if(!raw)return;
   const pending=JSON.parse(raw);
   sessionStorage.removeItem('kk_contact_pending');
   if(pending.path!==location.pathname||Date.now()-pending.time>1800000||Date.now()<pending.time)return;
   // Integration event ONLY; no direct GA4/Ads/Meta call. Avoid duplicate conversions.
   window.dataLayer=window.dataLayer||[];
   window.dataLayer.push({event:'kk_contact_success',form_type:'shopify_contact',event_id:pending.id,theme_preview:window.Shopify?.theme?.role!=='main'});
   success.dataset.kkEventPrepared='true';
  }catch{}
 }
 document.addEventListener('kk:consent-updated',completed);
 document.addEventListener('shopify:section:load',event=>prepare(event.target));
 function init(){
  prepare();completed();document.querySelector('[data-kk-contact-success]')?.focus({preventScroll:true});
  // Meety renders asynchronously: honor the booking anchor after its calendar exists.
  if(location.pathname===contactPath && location.hash==='#meety-book-component'){
   let observer;
   const go=()=>{const calendar=document.getElementById('meety-book-component');if(!calendar)return false;calendar.scrollIntoView({block:'start',behavior:'auto'});observer?.disconnect();return true;};
   if(!go()){observer=new MutationObserver(go);observer.observe(document.body,{childList:true,subtree:true});setTimeout(()=>observer.disconnect(),20000);}
  }
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
})();
